
export default "/assets/clipboard-micro.6fff387d.svg"